import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { createAppRouter } from '@/app/router'
import { useBoot } from '@/features/auth/useBoot'
import { BootScreen } from '@/components/shared/BootScreen'
import { OverlayHost } from '@/ds/overlay'
import { Connectivity } from '@/features/connectivity/Connectivity'
import { useThemeEffect } from '@/features/account/theme.store'
import { useLocaleStore } from '@/i18n/locale.store'
import { screenView } from '@/lib/analytics'
import { startActivityTracking } from '@/lib/activity'
import { setMonitoredUser } from '@/lib/monitoring'
import { useSessionStore } from '@/stores/session.store'
import { useEffect } from 'react'

// Before the first screen view, so it reaches /v2/events too (LP-947).
startActivityTracking()
const router = createAppRouter()
// Screen views by route pattern (ids stripped), once per navigation.
screenView(router.state.location.pathname)
router.subscribe((state) => screenView(state.location.pathname))

export function App() {
  const { phase, retry } = useBoot()
  useThemeEffect()
  const language = useLocaleStore((st) => st.language)
  document.documentElement.lang = language
  const userId = useSessionStore((st) => st.user?.id ?? null)
  useEffect(() => setMonitoredUser(userId), [userId])
  return (
    <>
      {phase !== 'ready' ? (
        <BootScreen phase={phase} onRetry={retry} />
      ) : (
        <Suspense fallback={<BootScreen phase="loading" />}>
          <RouterProvider router={router} />
        </Suspense>
      )}
      <OverlayHost />
      <Connectivity />
    </>
  )
}
